import { parseDomain, ParseResultType } from "parse-domain";
import themes from './themes.json';

const GetCurrentTheme = () => {
  if (typeof window === "undefined") {
    throw new Error("Window is not defined - try running this in a browser.")
  }

  const parseResult = parseDomain(window.location.hostname);

  // parse-domain 8.x returns an object with type property
  if (parseResult.type !== ParseResultType.Listed) {
    return themes["default"];
  }

  // In version 8.x, subDomains is an array
  const subDomains = parseResult.subDomains;
  const name = subDomains.length > 0 ? subDomains.join('.') : null;

  if (!name) {
    return themes["default"];
  }

  const selectedTheme = themes[name];

  if (!selectedTheme) {
    return themes["default"];
  }

  return selectedTheme;
}

export default GetCurrentTheme;